<template>
  <div>
    <v-row>
      <v-col cols="2">
        <v-select
          :items="['de', 'fr', 'it']"
          label="Language"
          v-if="$route.name === 'Tags'"
          v-model="language"
          @change="loadCurrentState"
        ></v-select>
      </v-col>
    </v-row>
    <v-row justify="space-between" align="start">
      <v-col cols="5">
        <v-list>
          <v-subheader>Tags</v-subheader>
          <v-list-item-group multiple>
            <v-list-item v-for="(item, i) in tags" :key="i" @click="toggle(i)">
              <v-list-item-action>
                <v-checkbox
                  readonly
                  v-model="item.active"
                  color="primary"
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title v-html="item.name"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col cols="1">
        <v-row justify="center" class="mb-4">
          <v-btn
            block
            color="success"
            :loading="saving"
            :disabled="saveDisabled"
            @click="save"
            >Save</v-btn
          >
        </v-row>
        <v-row justify="center">
          <v-btn block color="info" @click="loadCurrentState">Cancel</v-btn>
        </v-row>
      </v-col>
      <v-col cols="5">
        <v-list>
          <v-subheader>Active Tags</v-subheader>
          <draggable
            v-model="activeTags"
            group="tags"
            @change="saveDisabled = false"
          >
            <v-list-item v-for="(item, i) in activeTags" :key="i">
              <v-list-item-content>
                <v-list-item-title v-html="item"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </draggable>
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable
  },
  data() {
    return {
      activeTags: [],
      tags: [],
      saving: false,
      saveDisabled: true,
      language: "de"
    };
  },
  mounted() {
    this.loadCurrentState();
  },
  methods: {
    loadCurrentState: function() {
      this.saveDisabled = true;
      this.activeTags = [...this.$store.state.tags.tags.actives[this.language]];
      this.tags = this.$store.state.tags.tags.list[this.language].map(t => {
        return {
          name: t,
          active: this.activeTags.indexOf(t) !== -1
        };
      });
    },
    save: function() {
      this.saving = true;
      this.$store
        .dispatch("tags/patch", {
          actives: { [this.language]: this.activeTags }
        })
        .finally(() => {
          this.saving = false;
          this.saveDisabled = true;
        });
    },
    toggle: function(index) {
      this.saveDisabled = false;
      this.tags[index].active = !this.tags[index].active;
      if (this.tags[index].active) {
        this.activeTags.push(this.tags[index].name);
      } else {
        this.activeTags.splice(
          this.activeTags.indexOf(this.tags[index].name),
          1
        );
      }
    }
  }
};
</script>
